export const mapConfig = {
  account: 'svyatoslavdp',
  lightStyleId: 'clyygg6zx00c401nvbhp71sbj',
  darkStyleId: 'cltmscpol008v01pchp9a8mxa',
  get accessToken() {
    return process.env.NEXT_PUBLIC_MAPBOX_TOKEN
  },
}
